import Swiper, { Navigation, Pagination } from 'swiper';
import selectors from '../globals/selectors';

export default () =>
{
	const swiperArticlesDesktop = new Swiper('.swiper-articles-desktop', {
		slidesPerView: 1,
		slidesPerGroup: 1,
		autoHeight: true,
		modules: [Navigation],
		navigation: {
			nextEl: '.articles__button--next',
			prevEl: '.articles__button--prev',
		},
	});

	const swiperArticlesMobile = new Swiper(
		selectors.articles.carousel.mobile.element,
		{
			spaceBetween: 16,
			slidesPerView: 1,
			slidesPerGroup: 1,
			autoHeight: true,
			modules: [Pagination],
			pagination:
			{
				el: selectors.articles.carousel.mobile.pagination,
				type: 'bullets',
				dynamicBullets: true,
				dynamicMainBullets: 3,
			},
		}
	);

	const hideState = {
		'isHidden-1': true,
		'isHidden-2': true,
		'isHidden-3': true,
	};
	const isHidden = false;

	const articlesBtn = document.querySelectorAll('.articles__link');
	let swiper;
	let articlesContainer;
	if (window.innerWidth > 1400)
	{
		swiper = document.querySelector('.swiper-articles-desktop');
		articlesContainer = document.querySelector('.articles__container');
	}
	else
	{
		swiper = document.querySelector('.articles-mobile-carousel');
		articlesContainer = document.querySelector('.articles-mobile-card');
	}
	const sliderWrapper = swiper.querySelector('.swiper-wrapper');
	articlesBtn.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const listLink = btn.getAttribute('href');
			const number = +listLink.replace(/\D/gi, '');
			let list = [];
			let articles = [];
			if (!isHidden)
			{
				sliderWrapper.style.height = '100%';
				const lists = swiper.querySelectorAll('.articles__list');
				lists.forEach((item) => {
					list.push(...item.children);
				});
				articles = Array.from(list);
				swiper.classList.add('hidden');
				const ul = document.createElement('ul');
				ul.classList.add(['articles__list'], ['vertical']);
				for (let i = 0; i < articles.length; i++) {
					ul.innerHTML += articles[i].outerHTML;
				}
				const button = document.createElement('a');
				button.classList.add(['articles__hide'], ['btn--insert-shadow']);
				button.textContent = 'Скрыть';
				button.href = '#';
				ul.append(button);
				articlesContainer.append(ul);
				button.addEventListener('click', (e) => {
					e.preventDefault();
					swiper.classList.remove('hidden');
					document.querySelector('.articles__list.vertical').remove();
					document.querySelector('.articles__hide').remove();
				});
			}

			if (hideState[`isHidden-${number}`]) {
				articles.forEach((artilce) => {
					if (artilce.classList.contains('hidden')) {
						artilce.classList.remove('hidden');
					}
				});
			} else {
				articles.forEach((artilce, index) => {
					if (index > 2) {
						artilce.classList.add('hidden');
					}
				});
			}

			hideState[`isHidden-${number}`] = !hideState[`isHidden-${number}`];
			if (swiperArticlesDesktop) {
				swiperArticlesDesktop.update();
			} else {
				swiperArticlesMobile.update();
			}
		});
	});
};
